/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_Status_FilterInputs */

const id_staff_resellers_status_filter = /** @type {(inputs: Staff_Resellers_Status_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saring menurut status`)
};

const en_staff_resellers_status_filter = /** @type {(inputs: Staff_Resellers_Status_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by status`)
};

/**
* | output |
* | --- |
* | "Filter by status" |
*
* @param {Staff_Resellers_Status_FilterInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_status_filter = /** @type {((inputs?: Staff_Resellers_Status_FilterInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_Status_FilterInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_status_filter(inputs)
	return id_staff_resellers_status_filter(inputs)
});